module.exports = __webpack_public_path__ + "img/newProductContainer1.6c7761c1.png";